import Icon from '@ant-design/icons';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

const ShapesOutlinedSvg = () => (
  <svg
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.9}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="7.5" cy="7.5" r="3.8" />
    <rect x="13.3" y="3.7" width="7.2" height="7.2" rx="1.2" />
    <path d="M12 13.3L16.6 20.5H7.4Z" />
  </svg>
);

export const ShapesOutlined = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ShapesOutlinedSvg} {...props} />
);
